import { render, staticRenderFns } from "./TradeSidebar.vue?vue&type=template&id=0bdc4093"
import script from "./TradeSidebar.vue?vue&type=script&lang=ts"
export * from "./TradeSidebar.vue?vue&type=script&lang=ts"
import style0 from "./TradeSidebar.vue?vue&type=style&index=0&id=0bdc4093&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports